// src/utils/blogFormat.ts

/** Splits a headline so its last two words (or one, for short headlines) can be highlighted. */
export const splitCoverHighlight = (text: string): { lead: string; highlight: string } => {
  const words = text.split(' ');
  const highlightCount = words.length > 3 ? 2 : 1;
  return {
    lead: words.slice(0, -highlightCount).join(' '),
    highlight: words.slice(-highlightCount).join(' '),
  };
};

/** "2026-08-26" -> "August 26, 2026". Parsed as a calendar date so the time zone never shifts the day. */
export const formatPostDate = (isoDate: string): string => {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
};
